import { useEffect, useState } from 'react';

import useWindowSize from './useWindowSize';
import { Breakpoints } from '../types';

export const DESKTOP_ASPECT_RATIO_WIDTH = 1903;
const DESKTOP_ASPECT_RATIO_HEIGHT = 1080;

const DESKTOP_ASPECT_RATIO =
  DESKTOP_ASPECT_RATIO_WIDTH / DESKTOP_ASPECT_RATIO_HEIGHT;
const MOBILE_ASPECT_RATIO = 480 / 720; // is 4 / 6

const useContainerSize = () => {
  const [containerWidth, setContainerWidth] = useState<number>();
  const [containerHeight, setContainerHeight] = useState<number>();

  const { width, height } = useWindowSize();

  useEffect(() => {
    // Checking if width and height have been defined
    if (width == null || height == null) return;

    // Checking if current window size is vertical or horizontal based
    const aspectRatio = width / height;

    // Desktop screen size
    if (width > Breakpoints.md) {
      // Screen is wider than content width
      if (aspectRatio >= DESKTOP_ASPECT_RATIO) {
        setContainerWidth(
          Math.min(height, DESKTOP_ASPECT_RATIO_HEIGHT) * DESKTOP_ASPECT_RATIO
        );
        setContainerHeight(height);

        // Screen is taller than content height
      } else {
        setContainerWidth(Math.min(width, DESKTOP_ASPECT_RATIO_WIDTH));
        setContainerHeight(
          Math.min(width, DESKTOP_ASPECT_RATIO_WIDTH) / DESKTOP_ASPECT_RATIO
        );
      }

      // Mobile screen size
    } else {
      // Screen is wider than content width
      if (aspectRatio >= MOBILE_ASPECT_RATIO) {
        setContainerWidth(height * MOBILE_ASPECT_RATIO);
        setContainerHeight(height);

        // Screen is taller than content height
      } else {
        setContainerWidth(width);
        setContainerHeight(width / MOBILE_ASPECT_RATIO);
      }
    }
  }, [width, height]);

  return { width: containerWidth, height: containerHeight };
};

export default useContainerSize;
